module.exports = __webpack_public_path__ + "assets/img/color_of_button.4d47ba9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./website/assets/color_of_button.jpeg
// module id = Tg3l
// module chunks = 50